/**
 * Custom Javascript Code for Gutenberg Blocks.
 *
 * @author Eberhard Lauth
 *
 */
( function ( $ ) {
    
    /* Accordion for Yoast SEO strutctured data block FAQ */
    
    $('.wp-block-yoast-faq-block').addClass('accordion').attr('data-accordion','').attr('data-multi-expand','true').attr('data-allow-all-closed','true');
    $('.schema-faq-section').addClass('accordion-item').attr('data-accordion-item','');
    $('.schema-faq-question').wrap('<a href="#" class="accordion-title"></a>');
    $('.schema-faq-answer').addClass('accordion-content').attr('data-tab-content','');
    
} )( jQuery );